import { useNavigate, useOutletContext } from 'react-router-dom'

import { Section } from '@factorialco/deprecated-design-system'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AddOrEditPeriodModal from 'modules/work_schedules/components/AddOrEditPeriodModal'
import type { RouteContextParams } from 'modules/work_schedules/lib/RouteContextParams'
import overlapPeriods from 'modules/work_schedules/store/collections/overlapPeriods'
import schedules from 'modules/work_schedules/store/collections/schedules'

const EditPeriodModalPage = () => {
  const { navigation } = useNavigation()
  const { id, periodId } = useStrictParams<'id' | 'periodId'>()
  const period = overlapPeriods.get(Number(periodId))
  const workSchedule = schedules.get(Number(period?.attributes.schedule_id))
  const navigate = useNavigate()
  const { dayConfigurations } = useOutletContext<RouteContextParams>()
  const dayConfigurationsByPeriod = dayConfigurations.getDayConfigsByPeriod(Number(periodId))

  const onSuccess = () => {
    navigate(navigation.settings.workSchedule.id.fullPath({ id }))
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  return (
    <ResponsivePage.Body showHeader={false} variant="wide" loading={loading} error={null}>
      <Section.TwoThirds
        illustration="calendar-clock"
        title={i18n.t('settings.work_schedule.period_section.edit_period_modal.title')}
        description={i18n.t('settings.work_schedule.period_section.edit_period_modal.description')}
      >
        <AddOrEditPeriodModal
          onClose={onSuccess}
          onSuccess={onSuccess}
          period={period}
          workSchedule={workSchedule}
          dayConfigurations={dayConfigurationsByPeriod}
          contractVersions={contractVersions}
        />
      </Section.TwoThirds>
    </ResponsivePage.Body>
  )
}

export default EditPeriodModalPage
